import EventHandler from './EventHandler';
import progressStorage from './progressStorage';

class ProgressStorage {
  eventHandler: any;

  constructor() {
    this.eventHandler = new EventHandler();
  }

  subscribe() {
    this.eventHandler.on();
  }

  unsubscribe() {
    this.eventHandler.off();
  }

  use(storage: any) {
    progressStorage.use(storage);
  }

  get url() {
    return progressStorage.url;
  }

  get attemptId() {
    return progressStorage.attemptId;
  }

  get allQuestionsSubmitted() {
    return progressStorage.allQuestionsSubmitted;
  }

  get courseAttemptNumber() {
    return progressStorage.courseAttemptNumber;
  }

  get submitOnceAttempt() {
    return progressStorage.submitOnceAttempt;
  }

  get checklistItem() {
    return progressStorage.checklistItem;
  }

  get timeSpent() {
    return progressStorage.timeSpent;
  }

  get timer() {
    return progressStorage.timer;
  }

  getAnswers(questions: any) {
    return progressStorage.getAnswers(questions);
  }

  getRandomizeAnswers() {
    return progressStorage.randomizedOptionsList;
  }

  getQuestionPool() {
    return progressStorage.questionPool;
  }

  getCourseChecksum() {
    return progressStorage.courseChecksum;
  }

  restoreProgress() {
    return progressStorage.restoreProgress();
  }

  restoreAnswers() {
    return progressStorage.restoreAnswers();
  }

  checkScormNonAsciiSupport() {
    return progressStorage.checkScormNonAsciiSupport();
  }

  identifyUser() {
    return progressStorage.identifyUser();
  }

  userExists(email: any) {
    return progressStorage.userExists(email);
  }

  resetPassword(email: any) {
    return progressStorage.resetPassword(email);
  }

  authorizeUser(userData: any) {
    return progressStorage.authorizeUser(userData);
  }

  registerUser(userData: any) {
    return progressStorage.registerUser(userData);
  }

  removeProgress(isStartOver: boolean, urlToNavigate?: string | null) {
    return progressStorage.removeProgress(isStartOver, urlToNavigate);
  }

  sendSecretLink() {
    return progressStorage.sendSecretLink();
  }

  getSocialNetworkAuthLink(socialNetwork: any) {
    return progressStorage.getSocialNetworkAuthLink(socialNetwork);
  }

  isAuthenticated() {
    return progressStorage.isAuthenticated();
  }

  getHeaders({ contentType, bearerToken }: any) {
    return progressStorage.getHeaders({ contentType, bearerToken });
  }

  getToken() {
    return progressStorage.getToken();
  }

  mergeAccessibilitySettings(accessibilitySettings: any) {
    return progressStorage.mergeAccessibilitySettings(accessibilitySettings);
  }

  loadLocalAccessibilitySettings() {
    return progressStorage.loadLocalAccessibilitySettings();
  }
}

export default new ProgressStorage();
